export const CreateNewForm = (
    url:string,
    formSchema:string,
  ) => {
    return async (dispatch, getState) => {
      try {
        return fetch(url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formSchema)
        })
        .then((res) => {
          if (res.ok)
            return res.json();
          else
            throw Error(res.statusText);
        })
        .then((result) => {
          return result.formObject;
        });
      } catch (ex) {
        console.log(ex);
      }
    };
  };